
import { createContext } from "react";

import { Species, SubSpecies } from "../../api/dtos/dtos";


export interface ISpecies {
    species: Species,
    key?: string;
    subSpecies?: SubSpecies[]; 
}

export const DEFAULT_SPECIES_CONTEXT: ISpecies = {
    species: Species.None,
    key: undefined,
    subSpecies: undefined
}

interface ISpeciesContext {
    species: ISpecies
}

export const SpeciesContext = createContext<ISpeciesContext>({
    species: DEFAULT_SPECIES_CONTEXT
});